/**
 * Version salt for the render-app geometry cache.
 *
 * BUMP THIS whenever any geometry OUTPUT could change — i.e. any edit to
 * `workerGeo/*`, the CSG pipeline in `deviceMesh/deviceGeometryWorker.ts`,
 * `quality.ts` tessellation, or `computeBoxProjectionUVs` in `utils/geometry.ts`.
 *
 * Every cache key mixes in this value, so bumping it makes all prior entries
 * unreachable (content-addressed + version-salted). No migration or eviction is
 * needed — stale `_geometry-cache/*` objects simply stop being read and can be
 * wiped from S3 at any time.
 */
export const GEOMETRY_CACHE_VERSION = 1
